// @flow
import type { Trip } from "common/records/Trip/Trip"
import type { Flight } from "common/records/Flight/Flight"
import type JourneyProvider from "common/records/JourneyProvider"
import type { Transfer } from "common/records/Transfer/Transfer"
import type { SupportedJourneyHiddenTypes } from "common/services/journey/types"

export type DifferentAirports = { [number]: Object } // eslint-disable-line flowtype/no-weak-types
export type Layover = { [string]: any }
export type Layovers = Layover[]
export type ProvidersListType = JourneyProvider[]

export type Journey = {
  bookingToken: ?string,
  hasHoldBagsAllowed: boolean, // cannot be used in MMB
  sources: string[],
  trips: Trip[],
  transfers: Transfer[],
  flights: Flight[],
  id: ?number,
  prices: { default: number },
  quality: ?string,
  debugColor: string,
  debugString: string,
  // eslint-disable-next-line flowtype/no-weak-types
  _original: ?Object, // original response, only for debugging purposes only
  type: string,
  providers: JourneyProvider[],
  disabledBagsInMmb: boolean,
  hiddenFlightsType: SupportedJourneyHiddenTypes,
  // eslint-disable-next-line flowtype/no-weak-types
  getFlights: () => Array<Object>,
}

const defaultJourney = {
  bookingToken: null,
  hasHoldBagsAllowed: true, // cannot be used in MMB
  sources: [],
  trips: [],
  transfers: [],
  flights: [],
  id: null,
  prices: {},
  quality: null,
  debugColor: "",
  debugString: "",
  _original: null, // original response, only for debugging purposes only
  type: "oneWay",
  providers: [],
  disabledBagsInMmb: false,
  hiddenFlightsType: null,
}

export default defaultJourney
